import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";

export const parentTreatmentInitialState: TreatmentsContainerDto = {
  bookingName: "",
  description: "",
  type: 0,
  containerId: "",
  stepHeading: "",
  icon: "",
  isSpecialization: false,
  hideInDoctorBooking: false,
  ungroupInDoctorBooking: false,
  isTopLevelFallback: false,
  items: [],
};
